import { mergeApprovalPresentation } from '../utils/AntApprovalActions';
import React, { useEffect, useRef, useCallback, useMemo, useState, forwardRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { unpack, pack } from 'msgpackr';
import stringify from '../utils/stableStringify';

import { Template } from 'devextreme-react/core/template';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import { Button } from 'devextreme-react/button';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import AntLocalization from '../utils/AntLocalization';

import AntCondition from '../utils/AntCondition';
import AntConfig from '../utils/AntConfig';
import { isAIWizardAvailable } from '../utils/AntAIWizard';
import { AntGlobal, AntSession } from '../utils/AntContext';
import AntMessageBox from './AntMessageBox';
import './AntToolbar.css';

export default forwardRef(function (props, ref) {
    const navigate = useNavigate();
    const appGlobal = AntGlobal();
    // const session = AntSession();

    const mainTable = props.table ? props.table : props.API ? props.API.entityName : '';
    const mainConfig = useMemo(() => {
        if (!mainTable) return null;
        let found = appGlobal.tableConfigs?.find((t) => t.tableName === mainTable);
        if (found) return found.config;

        let cnf = new AntConfig(appGlobal, mainTable);
        // cnf.configFields(props.fields);

        if (appGlobal.tableConfigs instanceof Array === false) appGlobal.tableConfigs = [];

        appGlobal.tableConfigs.push({
            tableName: mainTable,
            config: cnf
        });
        return cnf;
    }, [props.table, props.API]);

    const [mainItems, setMainItems] = useState([]);

    const [processingName, setProcessingName] = useState(props.processingButton);

    const isDisabled = useMemo(() => processingName && mainItems.find((i) => i.waiting && i.name === processingName), [processingName, mainItems]);

    const msgBox = useRef();

    const [shouldRender, setShouldRender] = useState(1);

    const forceRender = useCallback(() => {
        setShouldRender((v) => v + 1);
    }, []);

    const _baseInitMenuItem = useCallback((obj) => {
        if (!obj) return null;

        var current = {
            valueExpr: obj.valueExpr,
            displayExpr: obj.displayExpr,
            icon: obj.icon,
            text: obj.label ? AntLocalization.translateText(obj.label) : AntLocalization.translateText(obj.text),

            value: obj.value,
            width: obj.width,
            stylingMode: obj.stylingMode ? obj.stylingMode : 'text'
        };

        if (obj.items instanceof Array && obj.items.length > 0) {
            current.items = [];

            obj.items.forEach((i) => {
                var child = _baseInitMenuItem(i);
                if (child) current.items.push(child);
            });
        }
        return current;
    }, []);

    const baseInitMenuItem = useCallback(
        (mItem) => {
            if (!mItem || !mItem.isMenu) return;

            var m = _baseInitMenuItem(mItem);
            if (m) {
                return {
                    ...mItem,
                    widget: 'Menu',
                    location: mItem.location,
                    items: [m]
                };
            }
        },
        [_baseInitMenuItem]
    );

    const _initMainItems = useCallback(() => {
        var cnfActions = [];
        if (props.showActions) {
            cnfActions.push(
                ...mainConfig.getCnfVoucherActions(
                    props.actionPack
                        ? props.actionPack
                        : props.table
                        ? props.table
                        : props.API
                        ? props.API.entityName
                        : props.API
                        ? props.API.entityName
                        : null
                )
            );
        }

        if (props.items instanceof Array)
            props.items.forEach((item) => {
                cnfActions.push(item);
            });

        var ar = [];

        var index = 1;
        let actionCodes = ['actionRelease', 'actionPost', 'actionApprove', 'actionReject'];

        for (let x = 0; x < actionCodes.length; x++) {
            const actionCode = actionCodes[x];

            if (props.parentData && props.parentData.actions instanceof Array) {
                for (let i = 0; i < props.parentData.actions.length; i++) {
                    const action = props.parentData.actions[i];
                    if (action.visible && action.name === actionCode) {
                        var found = cnfActions.find((a) => a.name === action.name);
                        var visible =
                            found && found.visible !== undefined ? AntCondition.isVisible(props.parentData, JSON.parse(stringify(found))) : true;

                        if (visible) {
                            if (action.name === 'actionRelease') {
                                if (!ar.some((a) => a.name === action.name))
                                    ar.push({
                                        icon: 'parentfolder',
                                        text: AntLocalization.translateText(
                                            props.actionRelease && props.actionRelease.text
                                                ? props.actionRelease.text
                                                : {
                                                      vi: 'Xác nhận',
                                                      en: 'Release',
                                                      fr: 'Libérer',
                                                      es: 'Liberar',
                                                      id: 'Rilis',
                                                      ja: 'リリース',
                                                      zh: '释放',
                                                      ko: '해제',
                                                      hi: 'रिलीज़',
                                                      ar: 'إصدار'
                                                  }
                                        ),
                                        name: 'actionRelease',
                                        waiting: true,
                                        widget: 'Button',
                                        index: index++
                                    });
                            } else if (action.name === 'actionPost') {
                                if (!ar.some((a) => a.name === action.name))
                                    ar.push({
                                        icon: props.actionPost && props.actionPost.icon ? props.actionPost.icon : 'upload',
                                        text: AntLocalization.translateText(
                                            props.actionPost && props.actionPost.text
                                                ? props.actionPost.text
                                                : {
                                                      vi: 'Ghi nhận',
                                                      en: 'Post',
                                                      fr: 'Publier',
                                                      es: 'Publicar',
                                                      id: 'Posting',
                                                      ja: '投稿',
                                                      zh: '发布',
                                                      ko: '게시',
                                                      hi: 'पोस्ट',
                                                      ar: 'نشر'
                                                  }
                                        ),
                                        name: 'actionPost',
                                        waiting: true,
                                        widget: 'Button',
                                        index: index++
                                    });
                            } else if (action.name === 'actionApprove') {
                                if (!ar.some((a) => a.name === action.name))
                                    ar.push({
                                        icon: 'check',
                                        text: AntLocalization.translateText({
                                            vi: 'Phê duyệt',
                                            en: 'Approve',
                                            fr: 'Approuver',
                                            es: 'Aprobar',
                                            id: 'Setuju',
                                            ja: '承認',
                                            zh: '批准',
                                            ko: '승인',
                                            hi: 'स्वीकृत',
                                            ar: 'موافقة'
                                        }),
                                        name: 'actionApprove',
                                        waiting: true,
                                        widget: 'Button',
                                        index: index++
                                    });
                            } else if (action.name === 'actionReject') {
                                if (!ar.some((a) => a.name === action.name))
                                    ar.push({
                                        icon: 'clear',
                                        text: AntLocalization.translateText({
                                            vi: 'Từ chối',
                                            en: 'Reject',
                                            fr: 'Rejeter',
                                            es: 'Rechazar',
                                            id: 'Tolak',
                                            ja: '却下',
                                            zh: '拒绝',
                                            ko: '거부',
                                            hi: 'अस्वीकार',
                                            ar: 'رفض'
                                        }),
                                        name: 'actionReject',
                                        waiting: true,
                                        widget: 'Button',
                                        index: index++
                                    });
                            }
                        }
                    }
                }
            }
        }

        cnfActions = mergeApprovalPresentation(cnfActions, props.parentData, props.showActions);

        if (cnfActions.length > 0) {
            for (let i = 0; i < cnfActions.length; i++) {
                const item = cnfActions[i];
                let strText = item.text instanceof Array ? AntCondition.getValue(props.parentData, item.text) : item.text;
                item.text = AntLocalization.translateText(strText);

                if (props.parentData) {
                    var visible = AntCondition.isVisible(props.parentData, JSON.parse(stringify(item)));
                    if (
                        visible &&
                        (!item.name || !['actionClose', 'actionCreate', 'actionCancel', 'actionDelete', 'actionClone'].includes(item.name))
                    ) {
                        if (item.isMenu) {
                            var mItem = baseInitMenuItem(item);
                            ar.push({ ...mItem, index: index++ });
                        } else if (!ar.some((a) => a.name === item.name)) ar.push({ ...item, index: index++ });
                    }
                } else {
                    if (!ar.some((a) => a.name === item.name)) ar.push({ ...item, index: index++ });
                }
            }
        }

        if (props.parentData && props.parentData.actions instanceof Array) {
            for (let i = 0; i < props.parentData.actions.length; i++) {
                const action = props.parentData.actions[i];
                if (action.visible) {
                    var found = cnfActions.find((a) => a.name === action.name);

                    var found2 = props.items instanceof Array ? props.items.find((a) => a.name === action.name) : {};

                    var visible =
                        found && found.visible !== undefined ? AntCondition.isVisible(props.parentData, JSON.parse(stringify(found))) : true;

                    if (visible) {
                        if (action.name === 'actionClose') {
                            if (!ar.some((a) => a.name === action.name))
                                ar.push({
                                    ...found,
                                    ...found2,
                                    icon: 'check',
                                    name: 'actionClose',
                                    waiting: true,
                                    text: AntLocalization.translateText(
                                        props.actionClose && props.actionClose.text
                                            ? props.actionClose.text
                                            : {
                                                  vi: 'Đóng',
                                                  en: 'Close',
                                                  fr: 'Fermer',
                                                  es: 'Cerrar',
                                                  id: 'Tutup',
                                                  ja: '閉じる',
                                                  zh: '关闭',
                                                  ko: '닫기',
                                                  hi: 'बंद करें',
                                                  ar: 'إغلاق'
                                              }
                                    ),
                                    index: index + 1,
                                    widget: 'Button'
                                });
                        } else if (action.name === 'actionCreate') {
                            if (!ar.some((a) => a.name === action.name))
                                ar.push({
                                    ...found,
                                    ...found2,
                                    icon: 'add',
                                    name: 'actionCreate',
                                    text: AntLocalization.translateText({
                                        vi: 'Tạo mới',
                                        en: 'New',
                                        fr: 'New',
                                        es: 'New',
                                        id: 'New',
                                        ja: 'New',
                                        zh: 'New',
                                        ko: 'New',
                                        hi: 'New',
                                        ar: 'New'
                                    }),
                                    waiting: true,
                                    // showText: 'inMenu',
                                    index: index + 2,
                                    widget: 'Button'
                                });
                        } else if (action.name === 'actionCancel') {
                            if (!ar.some((a) => a.name === action.name))
                                ar.push({
                                    ...found,
                                    ...found2,
                                    icon: 'clear',
                                    text: AntLocalization.translateText(
                                        props.actionCancel && props.actionCancel.text
                                            ? props.actionCancel.text
                                            : {
                                                  vi: 'Hủy phiếu',
                                                  en: 'Cancel',
                                                  fr: 'Annuler',
                                                  es: 'Cancelar',
                                                  id: 'Batal',
                                                  ja: 'キャンセル',
                                                  zh: '取消',
                                                  ko: '취소',
                                                  hi: 'रद्द करें',
                                                  ar: 'إلغاء'
                                              }
                                    ),
                                    name: 'actionCancel',
                                    waiting: true,
                                    showText: 'inMenu',
                                    index: index + 3,
                                    widget: 'Button'
                                });
                        } else if (action.name === 'actionDelete') {
                            if (!ar.some((a) => a.name === action.name))
                                ar.push({
                                    ...found,
                                    ...found2,
                                    icon: 'trash',
                                    text: AntLocalization.translateText(
                                        props.actionDelete && props.actionDelete.text
                                            ? props.actionDelete.text
                                            : {
                                                  vi: 'Xóa',
                                                  en: 'Delete',
                                                  fr: 'Supprimer',
                                                  es: 'Eliminar',
                                                  id: 'Hapus',
                                                  ja: '削除',
                                                  zh: '删除',
                                                  ko: '삭제',
                                                  hi: 'हटाएं',
                                                  ar: 'حذف'
                                              }
                                    ),
                                    name: 'actionDelete',
                                    waiting: true,
                                    showText: 'inMenu',
                                    index: index + 4,
                                    widget: 'Button'
                                });
                        } else if (action.name === 'actionClone') {
                            if (!ar.some((a) => a.name === action.name))
                                ar.push({
                                    ...found,
                                    ...found2,
                                    icon: 'copy',
                                    name: 'actionClone',
                                    text: AntLocalization.translateText({
                                        vi: 'Nhân bản',
                                        en: 'Clone',
                                        fr: 'Dupliquer',
                                        es: 'Duplicar',
                                        id: 'Duplikat',
                                        ja: '複製',
                                        zh: '复制',
                                        ko: '복제',
                                        hi: 'प्रतिलिपि',
                                        ar: 'نسخ'
                                    }),
                                    waiting: true,
                                    showText: 'inMenu',
                                    index: index + 5,
                                    widget: 'Button'
                                });
                        } else if (found && !ar.some((a) => a.name === action.name)) {
                            // Configured custom actions (for example Item's
                            // actionUpdate**** toggles) belong in the same
                            // Actions menu as built-ins. Their visibility still
                            // comes from the server row action payload.
                            ar.push({
                                ...found,
                                ...found2,
                                name: action.name,
                                icon: found2?.icon || found.icon || 'bulletlist',
                                text: found2?.text || found2?.label || found.text || found.label || action.name,
                                waiting: found2?.waiting !== undefined ? found2.waiting : found.waiting !== false,
                                showText: 'inMenu',
                                index: index + 6,
                                widget: 'Button'
                            });
                        }
                    }
                }
            }
        }

        if (props.items instanceof Array) {
            ar = ar.filter((item) => {
                var found = props.items.find((a) => a.name === item.name);
                return found && found.visible !== undefined ? AntCondition.isVisible(props.parentData, JSON.parse(stringify(found))) : true;
            });
        }

        ar = ar.sort((a, b) => (a.index > b.index ? 1 : -1));

        if (props.parentData && props.parentData.actions instanceof Array) {
            ar = ar.filter((item) => {
                if (item.clientAction === true) return true;
                var found = props.parentData.actions.find((a) => a.name === item.name);
                if (!found || !found.visible) return false;

                return AntCondition.isVisible(props.parentData, JSON.parse(stringify(found)));
            });
        }

        // Visibility ĐỒNG NHẤT với panel `aiWizard` ở AntLeftSidebar — xem
        // utils/AntAIWizard.js. 3 điều kiện: aiExtract.enabled + canAnalyze !== false
        // + current server-side AI entitlement/quota availability.
        if (props.parentData && isAIWizardAvailable(props.parentData.aiExtract)) {
            if (!ar.some((a) => a.name === 'actionUpdateWithDoc')) {
                var cloneItem = ar.find((a) => a.name === 'actionClone');
                var tipText = AntLocalization.translateText({
                    vi: 'Cập nhật từ tài liệu (AI)',
                    en: 'Update with Document (AI)',
                    fr: 'Mettre à jour via document (IA)',
                    es: 'Actualizar con documento (IA)',
                    id: 'Perbarui dari dokumen (AI)',
                    ja: 'AIで文書から更新',
                    zh: 'AI 文档更新',
                    ko: 'AI 文档로 업데이트',
                    hi: 'AI दस्तावेज़ से अपडेट',
                    ar: 'تحديث بواسطة المستند (AI)'
                });
                ar.push({
                    icon: 'wizard',
                    name: 'actionUpdateWithDoc',
                    text: tipText,
                    hint: tipText,
                    waiting: true,
                    showText: 'inMenu',
                    locateInMenu: 'auto',
                    index: cloneItem ? cloneItem.index + 0.5 : 9999,
                    widget: 'Button'
                });
                ar = ar.sort((a, b) => (a.index > b.index ? 1 : -1));
            }
        }

        ar = ar.map((a) => {
            a.text = AntLocalization.translateText(a.text);
            return a;
        });
        return ar;
    }, [mainConfig, baseInitMenuItem, props.showActions, props.actionPack, props.table, props.API, props.items, props.parentData]);

    const showAlert = useCallback((args, onClosedCallback) => {
        if (msgBox.current) msgBox.current.show(args, onClosedCallback);
    }, []);

    const onActionQuickCreate = useCallback(
        async (btn) => {
            var found = props.items.find((a) => a.name === btn.name);
            if (found) {
                let API = found.API ? found.API : props.API;
                var result = await API.postQuickCreate();
                if (result && result.error) {
                    showAlert({
                        content: result.error
                    });
                } else {
                    if (result.data) {
                        var code = result.data.code;
                        var id = result.data.id;

                        var value;
                        var link;

                        if (btn.options && btn.options.navigateLink) {
                            if (btn.options.navigateLink instanceof Array) {
                                btn.options.navigateLink.forEach((l) => {
                                    if (l && l.link) {
                                        if (l.when && typeof l.when === 'object') {
                                            var isValid = AntCondition.isValid(mainData, {
                                                when: l.when,
                                                whenType: l.whenType
                                            });
                                            if (!isValid) return;
                                        }
                                        value = l.field ? result.data[l.field] : result.data.code;
                                        link = String(l.link);
                                    }
                                });
                            } else {
                                let navField = btn.options.navigateField ? btn.options.navigateField : props.navigateField;
                                value = navField ? result.data[navField] : result.data.code;
                                link = String(btn.options.navigateLink);
                            }
                        } else {
                            value = code ? code : id;

                            link = String(location.pathname);
                            var ar = link.split('/');
                            if (ar.length > 0) ar.pop();
                            link = ar.join('/');
                        }

                        if (link && value !== undefined && value !== null) {
                            if (!link.startsWith('/')) link = '/' + link;
                            if (!link.endsWith('/')) link = link + '/';
                            link = link + value;

                            navigate(link);
                        }
                    }
                }
            }
        },
        [showAlert, props.items, props.API, props.navigateField]
    );

    const onActionConfirmed = useCallback(
        async (btn) => {
            if (!btn || !btn.name) return;

            // Bật trạng thái chờ cho MỌI nhánh — trước đây chỉ nút gắn trực tiếp trên bar
            // (onButtonClick) có; nút trong menu Actions (actionPack) bấm không có phản hồi.
            if (props.onActionProcessing) props.onActionProcessing(btn);
            try {

            // if (btn.validateRequired || ['actionRelease', 'actionCancel', 'actionClose', 'actionApprove', 'actionReject'].includes(btn.name))
            //     if (!(await this.validate())) {
            //         showAlert({
            //             title: 'Thông báo',
            //             content: 'Kiểm tra lại thông tin bắt buộc !'
            //         });
            //         return;
            //     }

            if (btn.name === 'actionCreate' && btn && btn.options && btn.options.isQuickCreate) {
                if (props.onActionQuickCreate) await props.onActionQuickCreate(btn);
                else await onActionQuickCreate(btn);
            } else if (btn.name === 'actionClone') {
                if (props.onActionClone) await props.onActionClone(btn);
            } else if (btn.name === 'actionCancel') {
                if (props.onActionCancel) await props.onActionCancel(btn);
            } else if (btn.name === 'actionDelete') {
                if (props.onActionDelete) await props.onActionDelete(btn);
            } else if (btn.name === 'actionRelease') {
                if (props.onActionRelease) await props.onActionRelease(btn);
            } else if (btn.name === 'actionClose') {
                if (props.onActionClose) await props.onActionClose(btn);
            } else if (btn.name === 'actionPost') {
                if (props.onActionPost) await props.onActionPost(btn);
            } else if (btn.name === 'actionApprove') {
                if (props.onActionApprove) await props.onActionApprove(btn);
            } else if (btn.name === 'actionReject') {
                if (props.onActionReject) await props.onActionReject(btn);
            } else if (btn.name === 'actionUpdateWithDoc') {
                if (props.onActionUpdateWithDoc) await props.onActionUpdateWithDoc(btn);
            } else {
                if (props.onAction) {
                    let result = await props.onAction(btn);
                    if (result && result.data) {
                        var code = result.data.code;
                        var id = result.data.id;

                        var value;
                        var link;

                        let opts = btn.options ? btn.options : btn;

                        if (opts && opts.navigateLink) {
                            if (opts.navigateLink instanceof Array) {
                                opts.navigateLink.forEach((l) => {
                                    if (l && l.link) {
                                        if (l.when && typeof l.when === 'object') {
                                            var isValid = AntCondition.isValid(mainData, {
                                                when: l.when,
                                                whenType: l.whenType
                                            });
                                            if (!isValid) return;
                                        }
                                        value = l.field ? result.data[l.field] : result.data.code;
                                        link = String(l.link);
                                    }
                                });
                            } else {
                                let navField = opts.navigateField ? opts.navigateField : props.navigateField;
                                value = navField ? result.data[navField] : result.data.code;
                                link = String(opts.navigateLink);
                            }
                        } else {
                            value = code ? code : id;

                            link = String(location.pathname);
                            var ar = link.split('/');
                            if (ar.length > 0) ar.pop();
                            link = ar.join('/');
                        }

                        if (link && value !== undefined && value !== null) {
                            if (!link.startsWith('/')) link = '/' + link;
                            if (!link.endsWith('/')) link = link + '/';
                            link = link + value;

                            navigate(link);
                        }
                    }
                }
            }
            } finally {
                if (props.onActionProceeed) props.onActionProceeed(btn);
            }
        },
        [
            onActionQuickCreate,
            props.onActionQuickCreate,
            props.onActionClone,
            props.onActionCancel,
            props.onActionDelete,
            props.onActionRelease,
            props.onActionClose,
            props.onActionApprove,
            props.onActionReject,
            props.onActionUpdateWithDoc,
            props.onAction,
            props.onActionProcessing,
            props.onActionProceeed,
            props.navigateField
        ]
    );

    const onAction = useCallback(
        async (btn, item) => {
            if (!btn || !btn.name) {
                return;
            }
            if (item) {
                var confirm = null;
                // if (item.name === 'actionClose') confirm = { message: 'Bạn có thực sự muốn đóng ?' };

                // if (item.name === 'actionDelete')
                //     confirm = {
                //         message: {
                //             vi: 'Bạn có thực sự muốn xóa ?',
                //             en: 'Are you sure you want to delete?'
                //         }
                //     };

                // if (item.name === 'actionCancel')
                //     confirm = {
                //         message: {
                //             vi: 'Bạn có thực sự muốn hủy ?',
                //             en: 'Are you sure you want to cancel?'
                //         }
                //     };

                if (item.confirm) confirm = item.confirm;
                if (confirm) {
                    var content = confirm.message
                        ? confirm.message
                        : {
                              vi: 'Bạn có muốn thực hiện không ?',
                              en: 'Are you sure ?',
                              fr: 'Êtes-vous sûr ?',
                              es: '¿Está seguro?',
                              id: 'Apakah Anda yakin?',
                              ja: 'よろしいですか？',
                              zh: '您确定吗？',
                              ko: '확실합니까?',
                              hi: 'क्या आप सुनिश्चित हैं?',
                              ar: 'هل أنت متأكد؟'
                          };
                    var title = confirm.title
                        ? confirm.title
                        : {
                              vi: 'Thông báo',
                              en: 'Warning',
                              fr: 'Avertissement',
                              es: 'Advertencia',
                              id: 'Peringatan',
                              ja: '警告',
                              zh: '警告',
                              ko: '경고',
                              hi: 'चेतावनी',
                              ar: 'تحذير'
                          };
                    var btnText = confirm.btnText
                        ? confirm.btnText
                        : { vi: 'Có', en: 'Yes', fr: 'Oui', es: 'Sí', id: 'Ya', ja: 'はい', zh: '是', ko: '예', hi: 'हां', ar: 'نعم' };

                    content = AntLocalization.translateText(content);
                    title = AntLocalization.translateText(title);
                    btnText = AntLocalization.translateText(btnText);

                    var btnWidth = confirm.btnWidth ? confirm.btnWidth : 150;

                    showAlert(
                        {
                            title: title,
                            content: content,
                            buttons: [{ width: btnWidth, icon: 'check', text: btnText, name: 'btnYes' }],
                            cancelText: AntLocalization.translateText({
                                vi: 'Không',
                                en: 'No',
                                fr: 'Non',
                                es: 'No',
                                id: 'Tidak',
                                ja: 'いいえ',
                                zh: '否',
                                ko: '아니오',
                                hi: 'नहीं',
                                ar: 'لا'
                            })
                        },
                        async (btnResult) => {
                            if (btnResult.name === 'btnYes') await onActionConfirmed({ ...btn, ...item });
                        }
                    );
                    return;
                } else {
                    await onActionConfirmed({ ...btn, ...item });
                }
            }
        },
        [onActionConfirmed, showAlert]
    );

    const initMainItems = useCallback(() => {
        var items = [];

        var title = AntCondition.getValue({}, props.title);
        title = AntLocalization.translateText(title);

        var isH4 = props.isH4;
        var isH5 = props.isH5;
        var isH6 = props.isH6;
        var upperCase = props.upperCase;

        if (upperCase) title = String(title).toUpperCase();

        if (props.showBack)
            items.push({
                name: 'actionBack',
                location: 'before',
                locateInMenu: 'never',
                widget: 'dxButton',
                showText: 'inMenu',
                cssClass: 'ant-back-button',
                options: {
                    icon: 'arrowleft',
                    stylingMode: 'text',
                    onClick: () => {
                        navigate(-1);
                    }
                }
            });

        const showHome = props.showHome !== undefined ? props.showHome : false;
        if (showHome)
            items.push({
                name: 'actionHome',
                location: 'before',
                locateInMenu: 'auto',
                widget: 'dxButton',
                showText: 'inMenu',
                options: {
                    icon: 'home',
                    stylingMode: 'text',
                    onClick: props.onHomeClick
                }
            });

        if (props.titleIcon)
            items.push({
                name: 'titleIcon',
                cssClass: 'ant-title-icon',
                location: 'before',
                locateInMenu: 'never',
                // widget: 'dxButton',
                showText: 'inMenu',
                // disabled: true,
                template: () => {
                    return (
                        // `<object
                        //     type="image/svg+xml"
                        //     data=${props.titleIcon}
                        // ></object>`

                        `<img src=${props.titleIcon}></img>`
                    );
                }
                // options: {
                //     icon: props.titleIcon,
                //     stylingMode: 'text',
                //     activeStateEnabled: false,
                //     focusStateEnabled: false,
                //     hoverStateEnabled: false,
                //     // disabled: true
                // }
            });

        if (!props.hideTitle)
            items.push({
                name: 'title',
                location: 'before',
                locateInMenu: 'auto',
                template: () => {
                    if (isH6) return `<h6 class='ant-screen-title'>${title}</h6>`;
                    if (isH5) return `<h5 class='ant-screen-title'>${title}</h5>`;
                    if (isH4) return `<h4 class='ant-screen-title'>${title}</h4>`;
                    else return `<h2 class='ant-screen-title'>${title}</h2>`;
                }
            });

        if (props.renderParent !== false) {
            var actionItems = _initMainItems();

            items.push(
                ...actionItems.map((item) => {
                    let wType = item.widget;
                    if (wType === 'CheckBox') wType = 'dxCheckBox';
                    if (wType === 'Button') wType = 'dxButton';
                    return {
                        name: item.name,
                        location: item.location ? item.location : 'after',
                        locateInMenu: item.locateInMenu ? item.locateInMenu : 'auto',
                        widget: wType ? wType : 'dxButton',
                        waiting: Boolean(item.waiting),
                        showText: item.showText !== undefined ? (item.showText === false ? 'inMenu' : item.showText) : 'always',
                        options: {
                            ...item.options,
                            items: item.items,
                            valueExpr: item.valueExpr,
                            displayExpr: item.displayExpr,
                            icon: item.icon,
                            text: item.label ? AntLocalization.translateText(item.label) : AntLocalization.translateText(item.text),

                            value: item.name,
                            width: item.width,
                            stylingMode: item.stylingMode ? item.stylingMode : 'text',
                            onClick: async (e, index) => {
                                if (item.name) {
                                    if (item.onClick) {
                                        await item.onClick({ name: item.name, value: item.value, text: item.text, index: index });
                                    } else if (onAction) {
                                        await onAction({ name: item.name, value: item.value, text: item.text, index: index }, item);
                                    }
                                }
                            },
                            onItemClick: async (e, index) => {
                                if (e.itemData && e.itemData.name) {
                                    if (item.onClick)
                                        await item.onClick({ name: e.itemData.name, value: e.itemData.value, text: e.itemData.text, index: index });
                                    else if (onAction)
                                        await onAction({ name: e.itemData.name, value: e.itemData.value, text: e.itemData.text, index: index }, item);
                                }
                            }
                        }
                    };
                })
            );
        }

        if (props.showFilter)
            items.push({
                name: 'gridFilter',
                location: 'after',
                locateInMenu: 'auto',
                widget: 'dxButton',
                showText: 'inMenu',
                options: {
                    icon: 'find',
                    text: AntLocalization.translateText({
                        vi: 'Bộ lọc',
                        en: 'Filters',
                        fr: 'Filtres',
                        es: 'Filtros',
                        id: 'Filter',
                        ja: 'フィルター',
                        zh: '筛选',
                        ko: '필터',
                        hi: 'फ़िल्टर',
                        ar: 'عوامل التصفية'
                    }),
                    stylingMode: 'text',
                    onClick: props.onFilterClick
                }
            });

        if (props.showDetail)
            items.push({
                name: 'actionDetail',
                location: 'after',
                locateInMenu: 'auto',
                widget: 'dxButton',
                showText: 'inMenu',
                options: {
                    icon: props.isDetailMode ? 'mediumiconslayout' : 'detailslayout',
                    text: AntLocalization.translateText({
                        vi: 'Chi tiết',
                        en: 'Detail',
                        fr: 'Détail',
                        es: 'Detalle',
                        id: 'Detail',
                        ja: '詳細',
                        zh: '详情',
                        ko: '상세',
                        hi: 'विवरण',
                        ar: 'تفاصيل'
                    }),

                    stylingMode: 'text',
                    onClick: props.onDetailClick
                }
            });

        let showPrint = props.renderParent !== false && (props.showPrint !== undefined ? props.showPrint : true);
        showPrint =
            showPrint &&
            props.parentData &&
            props.parentData.actions instanceof Array &&
            props.parentData.actions.some((a) => a.name === 'actionPrint' && a.visible);

        if (showPrint)
            items.push({
                name: 'actionPrint',
                location: 'after',
                locateInMenu: 'auto',
                widget: 'dxButton',
                showText: 'inMenu',
                options: {
                    icon: 'print',
                    text: AntLocalization.translateText({
                        vi: 'In Bill',
                        en: 'Print',
                        fr: 'Imprimer',
                        es: 'Imprimir',
                        id: 'Cetak',
                        ja: '印刷',
                        zh: '打印',
                        ko: '인쇄',
                        hi: 'प्रिंट',
                        ar: 'طباعة'
                    }),
                    stylingMode: 'text',
                    onClick: props.onPrintClick
                }
            });

        let showRecalculate = props.renderParent !== false && (props.showRecalculate !== undefined ? props.showRecalculate : true);

        showRecalculate =
            showRecalculate &&
            props.parentData &&
            props.parentData.actions instanceof Array &&
            props.parentData.actions.some((a) => a.name === 'actionRecalculate' && a.visible);

        if (showRecalculate)
            items.push({
                name: 'actionRecalculate',
                location: 'after',
                locateInMenu: 'always',
                widget: 'dxButton',
                showText: 'inMenu',
                options: {
                    icon: 'refresh',
                    text: AntLocalization.translateText({
                        vi: 'Tính lại',
                        en: 'Recalculate',
                        fr: 'Recalculer',
                        es: 'Recalcular',
                        id: 'Hitung ulang',
                        ja: '再計算',
                        zh: '重新计算',
                        ko: '재계산',
                        hi: 'पुनर्गणना',
                        ar: 'إعادة الحساب'
                    }),
                    stylingMode: 'text',
                    onClick: props.onRecalculateClick
                }
            });

        // Refresh hiện KỂ CẢ khi renderParent=false (BE lỗi/không phản hồi) — để user thử lại.
        const showRefresh = props.showRefresh !== undefined ? props.showRefresh : false;
        if (showRefresh)
            items.push({
                name: 'actionRefresh',
                location: 'after',
                locateInMenu: 'auto',
                widget: 'dxButton',
                showText: 'inMenu',
                waiting: true,
                options: {
                    icon: 'refresh',
                    text: AntLocalization.translateText({
                        vi: 'Làm mới',
                        en: 'Refresh',
                        fr: 'Actualiser',
                        es: 'Actualizar',
                        id: 'Segarkan',
                        ja: '更新',
                        zh: '刷新',
                        ko: '새로고침',
                        hi: 'ताज़ा करें',
                        ar: 'تحديث'
                    }),
                    stylingMode: 'text',
                    onClick: props.onRefreshClick
                }
            });

        if (props.flowToggle && props.flowToggle.hasData) {
            items.push({
                name: 'toggleFlow',
                location: 'after',
                locateInMenu: 'auto',
                widget: 'dxButton',
                showText: 'inMenu',
                options: {
                    icon: 'hierarchy',
                    text: AntLocalization.translateText({
                        vi: 'Sơ đồ luồng',
                        en: 'Voucher Flow',
                        fr: 'Flux document',
                        es: 'Flujo documento',
                        id: 'Alur dokumen',
                        ja: '伝票フロー',
                        zh: '单据流程',
                        ko: '전표 흐름',
                        hi: 'वाउचर प्रवाह',
                        ar: 'مسار المستند'
                    }),
                    stylingMode: 'text',
                    elementAttr: {
                        class: props.flowToggle.visible ? 'ant-toolbar-flow-active' : ''
                    },
                    onClick: props.flowToggle.onClick
                }
            });
        }

        const showSwitchUI = props.renderParent !== false && (props.showSwitchUI !== undefined ? props.showSwitchUI : false);
        if (showSwitchUI)
            items.push({
                name: 'showSwitchUI',
                location: 'before',
                locateInMenu: 'never',
                widget: 'dxButton',
                showText: 'inMenu',
                waiting: true,
                cssClass: 'ant-pos-toolbar-custom-icon',

                myRender: () => {
                    return <img src={appGlobal.appAssets.icons.color_sale}></img>;
                }

                // options: {
                //     icon: appGlobal.appAssets.icons.color_sale,
                //     text: AntLocalization.translateText({
                //         vi: 'Giao diện Desktop',
                //         en: 'Desktop UI'
                //     }),
                //     stylingMode: 'text',
                //     // onClick: props.onMessageClick
                // }
            });

        if (props.showMessage)
            items.push({
                name: 'showMessage',
                location: 'after',
                locateInMenu: 'auto',
                widget: 'dxButton',
                showText: 'inMenu',
                options: {
                    icon: 'message',
                    text: AntLocalization.translateText({
                        vi: 'Trao đổi',
                        en: 'Message',
                        fr: 'Discussion',
                        es: 'Discusión',
                        id: 'Diskusi',
                        ja: 'チャット',
                        zh: '讨论',
                        ko: '대화',
                        hi: 'चर्चा',
                        ar: 'نقاش'
                    }),
                    stylingMode: 'text',
                    onClick: props.onMessageClick
                }
            });

        const showHelp = props.renderParent !== false && (props.showHelp !== undefined ? props.showHelp : false);
        if (showHelp)
            items.push({
                name: 'actionHelp',
                location: 'after',
                locateInMenu: 'auto',
                widget: 'dxButton',
                showText: 'inMenu',
                options: {
                    icon: 'help',
                    text: AntLocalization.translateText({
                        vi: 'Trợ giúp',
                        en: 'Help',
                        fr: 'Aide',
                        es: 'Ayuda',
                        id: 'Bantuan',
                        ja: 'ヘルプ',
                        zh: '帮助',
                        ko: '도움말',
                        hi: 'मदद',
                        ar: 'مساعدة'
                    }),
                    stylingMode: 'text',
                    onClick: props.onHelpClick
                }
            });

        if (props.showDownload)
            items.push({
                name: 'actionDownload',
                location: 'after',
                locateInMenu: 'auto',
                widget: 'dxButton',
                showText: 'inMenu',
                options: {
                    icon: 'download',
                    stylingMode: 'text',
                    onClick: props.onDownloadClick
                }
            });
        items = items.filter((item) => Boolean(item));

        for (let i = 0; i < items.length; i++) {
            let item = items[i];
            item.disabled = Boolean(processingName && item.name !== processingName);
            if (item.waiting) item.template = 'renderButton';
        }
        return items;
    }, [
        processingName,
        onAction,
        _initMainItems,
        props.title,
        props.isH4,
        props.isH5,
        props.isH6,
        props.upperCase,
        props.showBack,
        props.showHome,
        props.onHomeClick,
        props.titleIcon,
        props.renderParent,
        props.parentData,
        props.showFilter,
        props.onFilterClick,
        props.showDetail,
        props.isDetailMode,
        props.onDetailClick,
        props.showPrint,
        props.onPrintClick,
        props.showRecalculate,
        props.onRecalculateClick,
        props.showRefresh,
        props.onRefreshClick,
        props.onMessageClick,
        props.showHelp,
        props.onHelpClick,
        props.showDownload,
        props.onDownloadClick
    ]);

    const setActionProgress = useCallback(
        (name, show, cb) => {
            if (processingName !== name) {
                var item = mainItems.find((f) => f.name === name);
                if (item) {
                    setProcessingName(show ? name : null);
                    if (cb) cb(item);
                }
            }
        },
        [processingName, mainItems]
    );

    const onButtonClick = useCallback(
        (e) => {
            if (!e.element.id || String(e.element.id).indexOf('ant-toolbar-button-id-') <= -1) return;

            let btnName = String(e.element.id).replace('ant-toolbar-button-id-', '');
            let item = mainItems.find((i) => i.name === btnName);
            let itemIndex = mainItems.findIndex((i) => i.name === btnName);

            if (item) {
                if (props.onActionProcessing) props.onActionProcessing(item);

                setActionProgress(item.name, true, async (item) => {
                    if (item && item.options && item.options.onClick) await item.options.onClick(item, itemIndex);

                    setActionProgress(item.name, false);
                    if (props.onActionProceeed) props.onActionProceeed(item);
                });
            }
        },
        [props.onActionProcessing, props.onActionProceeed, setActionProgress, mainItems]
    );

    // useEffect(() => {
    //     setMainItems(initMainItems());
    //     forceRender();
    // }, []);

    useEffect(() => {
        setMainItems(initMainItems());
        forceRender();
    }, [initMainItems]);

    useEffect(() => {
        setProcessingName(props.processingButton);
    }, [props.processingButton]);

    const renderButton = useCallback(
        (item) => {
            let isProcessing = processingName && item.name === processingName;

            let showText = item.showText !== 'inMenu' && item.options && item.options.text;

            let waitingIdcClass = showText ? 'ant-toolbar-icon-with-text' : 'ant-toolbar-icon';

            // Tooltip: DevExtreme Button.hint KHÔNG render title khi Button có children tùy biến,
            // nên gắn thẳng `title` HTML gốc vào nội dung (nút chỉ có icon → hover icon vẫn hiện).
            let tip = item.hint || (item.options && item.options.text) || item.text || '';

            return (
                <Button
                    id={'ant-toolbar-button-id-' + item.name}
                    onClick={onButtonClick}
                    type={'normal'}
                    hint={tip}
                    stylingMode={item.options && item.options.stylingMode ? item.options.stylingMode : 'text'}
                    // className="ant-processing-button"
                >
                    <span title={tip} style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <LoadIndicator
                            className={waitingIdcClass}
                            visible={isProcessing}
                            // style={{
                            //     display: !isProcessing ? 'none' : 'inline-block'
                            // }}
                        />

                        {item.myRender && item.myRender()}
                        {!item.myRender && item.options?.icon && (
                            <i
                                title={tip}
                                className={'dx-icon dx-icon-' + item.options.icon}
                                style={{
                                    marginRight: showText ? 9 : 0,
                                    display: isProcessing ? 'none' : 'inline-block'
                                }}
                            ></i>
                        )}
                        {!item.myRender && (
                            <span
                                id={'ant-toolbar-button-text-id-' + item.name}
                                className="dx-button-text"
                                style={{
                                    display: !showText ? 'none' : 'inline-block'
                                }}
                            >
                                {item.options ? item.options.text : item.text ? item.text : ''}
                            </span>
                        )}
                    </span>
                </Button>
            );
        },
        [processingName, onButtonClick, props.entityName]
    );

    return (
        <React.Fragment>
            {shouldRender && (
                <div style={{ width: '100%', display: mainItems?.length > 0 ? 'flex' : 'none' }}>
                    <Toolbar className="ant-toolbar" disabled={Boolean(isDisabled)} items={mainItems}>
                        {/* {mainItems.map((item, i) => {
                            if (item.waiting) {
                                let isProcessing = processingName && item.name === processingName;

                                let showText = item.showText !== 'inMenu' && item.options && item.options.text;

                                let waitingIdcClass = showText ? 'ant-toolbar-icon-with-text' : 'ant-toolbar-icon';

                                return (
                                    <Item {...item} key={props.entityName + '-' + item.name}>
                                        <Button
                                            id={'ant-toolbar-button-id-' + props.entityName + '-' + item.name}
                                            onClick={onButtonClick}
                                            type={'normal'}
                                            stylingMode={item.options && item.options.stylingMode ? item.options.stylingMode : 'text'}
                                            // className="ant-processing-button"
                                        >
                                            <LoadIndicator
                                                className={waitingIdcClass}
                                                visible={isProcessing}
                                                // style={{
                                                //     display: !isProcessing ? 'none' : 'inline-block'
                                                // }}
                                            />

                                            <i
                                                className={'dx-icon dx-icon-' + item.options.icon}
                                                style={{
                                                    marginRight: showText ? 9 : 0,
                                                    display: isProcessing ? 'none' : 'inline-block'
                                                }}
                                            ></i>

                                            <span
                                                id={'ant-toolbar-button-text-id-' + props.entityName + '-' + item.name}
                                                className="dx-button-text"
                                                style={{
                                                    display: !showText ? 'none' : 'inline-block'
                                                }}
                                            >
                                                {item.options ? item.options.text : item.text ? item.text : ''}
                                            </span>
                                        </Button>
                                    </Item>
                                );
                            } else {
                                if (processingName) {
                                    let _isDisabled = item.name !== processingName;
                                    return <Item {...item} key={props.entityName + '-' + item.name} disabled={item.name !== processingName} />;
                                }
                                return <Item {...item} key={props.entityName + '-' + item.name} />;
                            }
                        })} */}
                        <Template name={'renderButton'} render={renderButton} />
                    </Toolbar>
                    <AntMessageBox ref={msgBox} />
                </div>
            )}
        </React.Fragment>
    );
});
